import { render, staticRenderFns } from "./AlibabaLogisticsEdit.vue?vue&type=template&id=bc4a5a04&scoped=true&"
import script from "./AlibabaLogisticsEdit.vue?vue&type=script&lang=js&"
export * from "./AlibabaLogisticsEdit.vue?vue&type=script&lang=js&"
import style0 from "./AlibabaLogisticsEdit.vue?vue&type=style&index=0&id=bc4a5a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4a5a04",
  null
  
)

export default component.exports